import type { FC, SVGProps } from 'react';

/**
 * The two four-pointed stars from the AI Insight tab and panel header —
 * Figma node 248:20078 (`Star 1` 5x5, `Star 2` 3x3).
 *
 * Distinct from `ai-summary`, which pairs the same stars with the bird emblem.
 * The emblem is a brand mark and does not belong on the panel chrome, so this
 * icon carries the stars alone, at the design's 5:3 ratio.
 *
 * `currentColor` so the tab and the header can both tint it from their own text
 * color rather than baking white in.
 */
export const AIStarsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 1C6.311 3.622 8.378 5.689 11 6C8.378 6.311 6.311 8.378 6 11C5.689 8.378 3.622 6.311 1 6C3.622 5.689 5.689 3.622 6 1Z"
    />
    <path
      fill="currentColor"
      d="M12 8.8C12.199 10.478 13.522 11.801 15.2 12C13.522 12.199 12.199 13.522 12 15.2C11.801 13.522 10.478 12.199 8.8 12C10.478 11.801 11.801 10.478 12 8.8Z"
    />
  </svg>
);
